const baseStyle = {
    bg: 'white',
    borderRadius: 0,
    ring: 1,
    ringColor: 'transparent',
    shadow: '2'
};
const defaultProps = {};
const sizes = {};
const variants = {};
export default {
    baseStyle,
    defaultProps,
    sizes,
    variants
};
